import { getEnv } from '@risksmart-app/components/src/utils/environment';

interface ProductlaneInitConfig {
  widgetKey: string;
  position: 'left' | 'right';
  theme: Record<string, string>;
}

interface ProductlaneApi {
  init: (config: ProductlaneInitConfig) => void;
  set: (...args: unknown[]) => void;
  open: (...args: unknown[]) => void;
  close: (...args: unknown[]) => void;
  toggle: (...args: unknown[]) => void;
  on: (...args: unknown[]) => void;
  off: (...args: unknown[]) => void;
}

declare global {
  interface Window {
    // Stubbed as a queue in index.html, then replaced by the real widget
    // bundle (https://widget.productlane.com/latest.productlane-widget.min.js)
    // once it loads. May be undefined if the widget script is blocked.
    Productlane?: ProductlaneApi;
  }
}

const PRODUCTLANE_CONFIG: ProductlaneInitConfig = {
  widgetKey: '8221e165-0f1a-44cf-9722-d742f5a65af2',
  position: 'left',
  theme: {
    '--text-color-primary': '#111827',
    '--text-color-primary-dark': '#FFFFFF',
    '--text-color-secondary': '#9CA3AF',
    '--text-color-secondary-dark': '#9CA3AF',
    '--text-color-highlight': '#1692A4',
    '--text-color-highlight-dark': '#1692A4',
    '--background-color-primary': '#FFFFFF',
    '--background-color-primary-dark': '#111827',
    '--background-color-secondary': '#F3F4F6',
    '--background-color-secondary-dark': '#1F2937',
    '--border-color-primary': '#E5E7EB',
    '--border-color-primary-dark': '#1F2937',
  },
};

/**
 * Initialises the Productlane support widget unless disabled via
 * REACT_APP_DISABLE_PRODUCTLANE. The queue stub in index.html captures this
 * call and hands it to the widget bundle once it has loaded.
 */
export const initProductlane = (): void => {
  if (getEnv('REACT_APP_DISABLE_PRODUCTLANE', true) === 'true') {
    return;
  }

  window.Productlane?.init(PRODUCTLANE_CONFIG);
};
